import { render, staticRenderFns } from "./SpouseIndicators.vue?vue&type=template&id=64caf88a&scoped=true&"
import script from "./SpouseIndicators.vue?vue&type=script&lang=js&"
export * from "./SpouseIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64caf88a",
  null
  
)

export default component.exports